"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSubspaceBrazeBody = exports.subspaceBrazeRequest = void 0;
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const config_1 = require("../config");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const fluture_utils_1 = require("../utils/fluture-utils");
const buildFetchOptions = (method, body) => ({
    body: JSON.stringify((0, exports.buildSubspaceBrazeBody)(body)),
    headers: {
        'Accept': 'application/json',
        'Accept-Language': body.locale,
        'Content-Type': 'application/json'
    },
    method,
});
const subspaceBrazeRequest = (body) => (handleFailure) => (handleSuccess) => {
    const options = buildFetchOptions('POST', body);
    const endpoint = `${config_1.leadsApiUrl}/leads/v1/event/capture`;
    return (0, fluture_1.attemptP)(() => fetch(endpoint, options))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptNoContent))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default))
        .pipe((0, fluture_1.fork)((e) => {
        handleFailure && handleFailure(e);
    })(handleSuccess));
};
exports.subspaceBrazeRequest = subspaceBrazeRequest;
const buildSubspaceBrazeBody = (body) => ({
    attributes: body.attributes,
    events: body.events,
    userData: body.userData
});
exports.buildSubspaceBrazeBody = buildSubspaceBrazeBody;
//# sourceMappingURL=subspace.js.map